import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ReportModalDialogComponent } from '../report-modal-dialog/report-modal-dialog.component';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-once-off-invoice',
  templateUrl: './once-off-invoice.component.html',
  styleUrls: ['./once-off-invoice.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})

export class OnceOffInvoiceComponent implements OnInit {
  onceOffForm: FormGroup;
  IsHaveTable: boolean = false;
  customerBalance: any;
  minDate: Date;
  selectedDate: any
  maxDate: Date;
  date = new FormControl(moment());
  @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toast: NotificationService
  ) { }

  ngOnInit(): void {
    this.initializeValidators();
    this.maxDate = new Date(new Date().setDate(new Date().getDate()));
    this.Reset();
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value ?? moment();
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    this.selectedDate = ctrlValue;
    this.onceOffForm.controls['startDate'].setValue(ctrlValue);
    // this.generateInvoice();
    datepicker.close();
  }

  OpenDatePicker() {
    this.startDatePicker.open();
  }

  initializeValidators() {
    this.onceOffForm = this.fb.group({ startDate: ['', Validators.required] });
  }

  generateInvoice() {
    if (this.onceOffForm.valid) {
      let formValues = this.onceOffForm.getRawValue();
      let startValue = moment(formValues.startDate).format('YYYY/MM/DD');
      this.dialog.open(ReportModalDialogComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: '550px',
        data: {
          displayPanel: 'SendOverEmail',
          reportType: 4,
          startDate: startValue,
        }
      });
    } else {
      this.toast.showError('Please fill the required fields!');
      this.onceOffForm.markAllAsTouched();
    }
  }

  Reset() {
    this.onceOffForm.reset();
  }

}
